import "./PrivacyDataProtection.module.css";
import Header from "@/reusable_sections/Header";
import Privacy from "./sections/Privacy";
import CookiePolicy from "./sections/CookiePolicy";
import PrivacyRights from "./sections/PrivacyRights";
import Preferences from "./sections/Preferences";
import Retention from "./sections/Retention";
import Security from "./sections/Security";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyDataProtectionPage() {
  return <div>
      <Header />
      <Privacy />
      <CookiePolicy />
      <PrivacyRights />
      <Preferences />
      <Retention />
      <Security />
      <Footer />
    </div>;
}